export default __webpack_public_path__ + "static/media/home.d8ce187c.svg";